import type {
  ThresholdBreachesResult,
  ThresholdsResult,
} from '@highimpact-frontend/api-types';
import { CachedDataState, ExternalsWithParams } from './initials';
import {
  isDataState,
  isErrorState,
  isIdleState,
  isLoadingState,
  type State,
} from './state';

export type PermittedAction = { [key: string]: boolean };

export type ConfigTableType<T extends object> = State<
  string,
  Record<string, T>
>;

export type MeasureType = Record<string, string | number | boolean | null>[];

export interface MeasureThresholdMetadata {
  thresholds?: ThresholdsResult;
  threshold_breaches?: ThresholdBreachesResult;
}

type idType = string;
type ParamKey = string;
type EntityId = string;

export type ConfigTableByParams<T> = {
  type: 'ByParams';
  id: ExternalsWithParams;
  value: Record<ParamKey, State<idType, Record<EntityId, T>>>;
};

export const isByParams = (
  s:
    | ConfigTableByParams<unknown>
    | State<idType, Record<EntityId, unknown>>
    | CachedDataState<unknown>
): s is ConfigTableByParams<unknown> => s.type === 'ByParams';

export const isCachedDataState = (
  s:
    | ConfigTableByParams<unknown>
    | State<idType, Record<EntityId, unknown>>
    | CachedDataState<unknown>
): s is ConfigTableByParams<unknown> => s.type === 'cached';

export const isStateOfRecord = (
  s:
    | ConfigTableByParams<unknown>
    | State<idType, Record<EntityId, unknown>>
    | CachedDataState<unknown>
): s is State<idType, Record<EntityId, unknown>> =>
  !isByParams(s) && !isCachedDataState(s);

export const iscachedIdleState: (
  obj: CachedDataState<unknown>
) => obj is { _tag: 'idle'; type: 'cached'; id: string } = isIdleState as any;

export const isCachedLoadingState: (
  obj: CachedDataState<unknown>
) => obj is { _tag: 'loading'; type: 'cached'; id: string } =
  isLoadingState as any;

export const isCachedDataDataState: (
  obj: CachedDataState<unknown>
) => obj is { _tag: 'data'; type: 'cached'; data: unknown; id: string } =
  isDataState as any;

export const isCachedErrorState: (
  obj: CachedDataState<unknown>
) => obj is { _tag: 'error'; type: 'cached'; error: string; id: string } =
  isErrorState as any;
